import { useCallback } from 'react';

/**
 * 用于输入框 onBlur 时自动去除前后空格并设置表单值的 Hook
 * @param {Function} setFieldValue - 设置表单字段值的方法
 * @param {string} name - 字段名
 * @returns {Function} - 可直接绑定到 Input 的 onBlur
 */
function useInputTrim(setFieldValue, name) {
  return useCallback(
    (e) => {
      const value = e.target.value.trim();
      setFieldValue(name, value);
    },
    [setFieldValue, name],
  );
}

export default useInputTrim;
